export function formatActiveLanguageForRegion(language: string, region: string): string {
  return `${language}/${region}`;
}
